// extracted by mini-css-extract-plugin
export var bold = "_sl-0";